import React, { useEffect, useState} from 'react';
import { SearchIcon, EditQc, DeleteQc, SiteDefault, SiteSelected, InterfaceDisable, InterfaceDefault, InterfaceSelected, DevicesDisable, DevicesDefault, DevicesSelected, AddNode, SearchIconWhite, RemoveIcon, EditRowBlue, DeleteRowBlue, CheckRowBlue, CancelRowBlue } from '../../../../assets/images'
import { addEmergencyContactBySite, updateEmergencyContactBySite, deleteEmergencyContactsBysite, getEmergencyContactsBysite, getCategoryIdlist } from "../../../../services/configurationServices";
import { toast } from "react-toastify";
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import Swal from 'sweetalert2';
// import { SuccessToast } from "./"
// import { ErrorToast } from "../CustomHooks/ErrorToast"


const EmergencyContactForm = ({item, getEmergencyContact, categoryIdList, masterData}) =>{
    // console.log("SITEISSUE", item)
    // console.log("categoryIdList", categoryIdList)
    let arr = categoryIdList?.map(val => val.LevelLimit); 
    const [emergencyContactID, setEmergencyContactID] = useState(item.EmergencyContactID)
    const [name, setName] = useState(item.ContactName);
    const [contact, setContact] = useState(item.Phone);
    const [email, setEmail] = useState(item.EmailID);
    const [Category, setCategory] = useState(item.CategoryID);
    const [isEditMode, setIsEditMode] = useState(false)
    const [siteId, setSiteId] = useState(item.SiteID);
    const [contactLevel, setContactLevel] = useState(item.ContactLevel)
    const [contactLevelOptions, setContactLevelOptions] = useState([]);
    

    
    console.log("SITEISSUE", siteId)

    
  useEffect(() => {
    setName(item.ContactName);
    setContact(item.Phone);
    setEmail(item.EmailID);
    setCategory(item.CategoryID);
    const newCategory = item.CategoryID;
    setCategory(newCategory);
    const selectedCategory = categoryIdList?.find(cat => cat.CategoryID === parseInt(newCategory));
    if (selectedCategory) {
      const levelLimit = selectedCategory.LevelLimit;
      const newContactLevelOptions = Array.from({ length: levelLimit }, (_, index) => index + 1);
      setContactLevelOptions(newContactLevelOptions);
      setContactLevel(newContactLevelOptions[0]); 
    }

    setContactLevel(item.ContactLevel);
    setSiteId(item.SiteID)
    if (item.EmergencyContactID === 0) {
      setIsEditMode(true)
    }
    // }else{
    //   setIsEditMode(false)
    // }

  }, [item]);

    const nameRegex = (event) => {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
      const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
      if (!isValid) {
          event.preventDefault();
          return;
      }
    };

    const numberRegex = (event) => {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
      const isValid = new RegExp("[0-9]").test(keyValue);
      if (!isValid || event.target.value.length >= 10) {
          event.preventDefault();
          return;
      }
    };

    const emailRegex = (event) => {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
  
      const isValid = /[a-zA-Z0-9._%+-@]/.test(keyValue);
  
      if (!isValid) {
        event.preventDefault();
        // return;
      }
    };

    const showErrorToast = (msg) => {
      toast.error(msg, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    };

    const mobileHandler = (e) => {
      setContact(e.target.value);
    }

    const emailHandler = (e) => {
        setEmail(e.target.value);
    }

    const nameHandler = (e) => {
        setName(e.target.value);
    }

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setCategory(newCategory);
    
      const selectedCategory = categoryIdList?.find(cat => cat.CategoryID === parseInt(newCategory));

    // If category is found, update contact level range
      if (selectedCategory) {
        const levelLimit = selectedCategory.LevelLimit;
      // console.log("levelLimit", levelLimit)
        const newContactLevelOptions = Array.from({ length: levelLimit }, (_, index) => index + 1);

        setContactLevelOptions(newContactLevelOptions);
        setContactLevel(newContactLevelOptions[0]); // Set default contact level to 1 (or any other logic you prefer)
    }
  };
  

    const handleContactLevelChange = async (e) => {
      const newContactLevel = e.target.value;
      setContactLevel(newContactLevel);
    }

  //   const validateForm = () => {
  //     if (contact.length !== 10) {
  //         showErrorToast("Please enter a valid 10-digit mobile number.");
  //         return false; // Validation failed
  //     }
  //     // console.log("Category", Category)
  //     // console.log("contactExistsItem", masterData)
  //     // console.log("contactExistsItems", item)
  //     const contactExists = masterData && masterData.some(record => record.Phone == contact && record.EmergencyContactID != item.EmergencyContactID);
  //     // console.log("contactExists", contactExists)
  //     if (contactExists) {
  //       showErrorToast("This contact number already exists.");
  //       return false; // Validation failed
  //     }

  //     if (Category == "" || Category == "0") {
  //         showErrorToast("Please select a category before adding the record.");
  //         return false; // Validation failed
  //     }
  //     // console.log("Category.contactLevel", contactLevel)

  //     if (contactLevel == "" || contactLevel == "0") {
  //       showErrorToast("Please select a ContactLevel before adding the record.");
  //       return false; // Validation failed
  //   }
  //     return true; // Validation passed
  // };

    const validateForm = () => {
      if (contact.length !== 10) {
          showErrorToast("Please enter a valid 10-digit mobile number.");
          return false; // Validation failed
      }
      // console.log("Category", Category)
      // console.log("contactExistsItem", masterData)
      // console.log("contactExistsItems", item)
      const contactExists = masterData && masterData.some(record => record.Phone == contact && record.EmergencyContactID != item.EmergencyContactID);
      // console.log("contactExists", contactExists)
      if (contactExists) {
        showErrorToast("This contact number already exists.");
        return false; // Validation failed
      }

      if (Category == "" || Category == "0") {
          showErrorToast("Please select a category before adding the record.");
          return false; // Validation failed
      }
      // console.log("Category.contactLevel", contactLevel)

      if (contactLevel == "" || contactLevel == "0") {
        showErrorToast("Please select a ContactLevel before adding the record.");
        return false; // Validation failed
    }
      return true; // Validation passed
  };


    const onSaveEmergencyContact = () => {
    if (!validateForm()) return;
    // console.log("Category", Category);
    // console.log("Category Contact", contact);
    // console.log("Category ContactLevel", contactLevel);
    // console.log("onSaveEmergencyContact")
    if(emergencyContactID == "" || emergencyContactID == 0){
    let addEmergencyContactObj = {
      "SiteID": (siteId).toString(),
      "ContactName": (name).toString(),
      "Phone": (contact).toString(),
      "SMS": "",
      "Email": "",
      "WhatsApp": "",
      "CreatedOn": "",
      "CreatedBy": "",
      "ModifiedOn": "",
      "ModifiedBy": "",
      "EmailID": (email) ? (email).toString() : "" ,
      "IsCall": "",
      "InApp": "",
      "SubscriptionArn": "",
      "UserID": "",
      "ContactLevel": (contactLevel).toString(),
      "Designation": "" ,
      "IsERT": "",
      "IsCustomerSPOC": "",
      "OrganizationMasterID": JSON.parse(localStorage.getItem('user')).OrganizationMasterID.toString(),
      "CategoryID": (Category).toString(),
      "CategoryName" : "",
      "UpdatedateTime": ""
    }

    addEmergencyContactBySite(addEmergencyContactObj).then((resp) => {
      // console.log("APIHit", addEmergencyContactObj)
      if (resp.Status == "success") {
        SuccessToast(resp.Message);
        setIsEditMode(false)
        getEmergencyContact(siteId)
        setContactLevel(contactLevel);
      }
      else {
        showErrorToast(resp.Message)
        console.error(resp.Message)
      }
    })} else {
        let updateAlertPrePostDetailsObj = {
        "EmergencyContactID" : (emergencyContactID).toString(),
        "SiteID": (siteId).toString(),
        "ContactName": (name).toString(),
        "Phone": (contact),
        "SMS": "",
        "Email": "",
        "WhatsApp": "",
        "CreatedOn": "",
        "CreatedBy": "",
        "ModifiedOn": "",
        "ModifiedBy": "",
        "EmailID": (email) ? (email).toString() : "",
        "IsCall": "",
        "InApp": "",
        "SubscriptionArn": "",
        "UserID": "",
        "ContactLevel": (contactLevel).toString(),
        "Designation": "",
        "IsERT": "",
        "IsCustomerSPOC": "",
        "OrganizationMasterID": JSON.parse(localStorage.getItem('user')).OrganizationMasterID.toString(),
        "CategoryID": (Category).toString(),
        "CategoryName" :  "",
        "UpdatedateTime": ""
       }
      updateEmergencyContactBySite(updateAlertPrePostDetailsObj).then((resp) => {
        if (resp.Status == "success") {
          SuccessToast(resp.Message);
          setIsEditMode(false)
          // getEmergencyContact(item.SiteID)
        }
        else {
          showErrorToast(resp.Message)
          console.error(resp.Message)
        }
      })
    }
}

  const onCancel = (e) => {
    e.stopPropagation()
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to cancel the changes made?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#027aaa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Leave!"
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false)
        getEmergencyContact(siteId) 
      }
    })
  }

  const onDeleteChange = (e) => {
    try {
      if(emergencyContactID == "" || emergencyContactID == 0){
        console.log("Invalid Emergency Contact ID");
        return; 
      }
       e.stopPropagation(); 

      // Show the confirmation dialog
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa", 
        cancelButtonColor: "#d33", 
        confirmButtonText: "Yes, Delete!", 
        cancelButtonText: "No, Cancel" 
      }).then((result) => {
        if (result.isConfirmed) {
          // If confirmed, proceed with the delete operation
          deleteEmergencyContactsBysite(emergencyContactID).then((resp) => {
            if (resp != undefined) {
              if (resp.Status == "success") {
                SuccessToast(resp.Message);
                setIsEditMode(false);
                // console.log("setIsEditMode", setIsEditMode)
                getEmergencyContact(siteId); // Refresh the contact list
              } else {
                showErrorToast(resp.Message);
              }
            }
          });
        } else {
          // If cancelled, just exit
          console.log("Delete action was canceled");
        }
      });
    } catch (error) {
      console.error(error)
    }
  }


    return (
      <tr>
      <td>
          {/* <div className="inputTypeLabelContainer removeBorder"> */}
          <div className={!isEditMode ? 'inputTypeLabelContainer removeBorder' : 'inputTypeLabelContainer'}>
            <input className="inputType"
              placeholder="Ex. Kumar Khan"
              style={{fontSize:"14px"}}
              value={name}
              onChange={(e) =>{ 
                nameHandler(e)
              }}
              onKeyPress={nameRegex}
              readOnly={!isEditMode}

            />
          </div>
      </td>
      <td>
          <div className={!isEditMode ? 'inputTypeLabelContainer removeBorder' : 'inputTypeLabelContainer'}>
            <input className="inputType"
              placeholder="Ex. kkhan@rmail.com"
              style={{fontSize:"14px"}}
              value={email}
              onChange={(e) => {
                emailHandler(e)
              }}
              onKeyPress={emailRegex}
              readOnly={!isEditMode}

            />
          </div>
      </td>
      <td>
          <div className={!isEditMode ? 'inputTypeLabelContainer removeBorder' : 'inputTypeLabelContainer'}>
            <input className="inputType"
              placeholder="Ex. 9898989898"
              style={{fontSize:"14px"}}
              value={contact} 
              onChange={(e) => {
                mobileHandler(e)
              }}
              onKeyPress={numberRegex}
              // onBlur={handleSubmit} 
              readOnly={!isEditMode}
            />
          </div>
      </td>
      <td>
      <div className={!isEditMode ? 'inputTypeLabelContainer removeBorder' : 'inputTypeLabelContainer'}>
            <select className="inputType ArrowSelectClass" 
              value={Category}
              onChange={(e) => handleCategoryChange(e)}
              readOnly={!isEditMode}
              disabled={!isEditMode}
              >
              <option key="0" disabled={false} value="0" id="0">Select</option>
              {categoryIdList &&
                categoryIdList.map((item) => (
                  <option value={item.CategoryID} key={item.CategoryID}>
                    {item.CategoryName}
                  </option>
                ))}
               
            </select>
      </div>
      </td>
      <td>  
          <div className={!isEditMode ? 'inputTypeLabelContainer removeBorder' : 'inputTypeLabelContainer'}>
            <select className="inputType ArrowSelectClass" 
              value={contactLevel}
              onChange={handleContactLevelChange}
              readOnly={!isEditMode}
              disabled={!isEditMode}
              >
              <option key="0" disabled={false} value="0" id="0">Select</option>
              
               {contactLevelOptions.map((level) => (
               <option value={level} key={level}>
                  {level}
               </option>
          ))}
            </select>
          </div>
      </td>  
      {/* <td style={{width:"135px"}}>
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"35px"}}>
          <input type="checkbox"/>
        </div>
      </td> */}
      <td style={{width:"100px"}}>
        <div style={{display:"flex", justifyContent:"space-between", height:"35px"}}>
          {
            !isEditMode
            ?
            <button style={{background:"transparent"}} onClick={() => setIsEditMode(true)}>
                                      <img className="EyeIcon" alt="Search-icon" src={EditRowBlue} /> 
                                      {/* <img className="EyeIcon" alt="Search-icon" src={CheckRowBlue} />  */}
                                  </button>
            :
            <button style={{background:"transparent"}} onClick={onSaveEmergencyContact}>
            {/* <img className="EyeIcon" alt="Search-icon" src={EditRowBlue} />  */}
            <img className="EyeIcon" alt="Search-icon" src={CheckRowBlue} /> 
            </button>
          }

          <button style={{background:"transparent"}} hidden={!isEditMode} onClick={(e) => {
            onCancel(e)
            // setIsEditMode(false)
            // getEmergencyContact(siteId)
            // hidden={isEditMode}
            }}>
              {/* <img className="EyeIcon" alt="Search-icon" src={DeleteRowBlue} />  */}
              <img className="EyeIcon" alt="Search-icon" src={CancelRowBlue} /> 
          </button>
          <button style={{background:"transparent"}} hidden={isEditMode} onClick={onDeleteChange}>
          <img className="EyeIcon" alt="Search-icon" src={DeleteRowBlue} /> 
          </button>
        </div>
      </td>                              
    </tr>

    )
}

export default EmergencyContactForm